// extracted by mini-css-extract-plugin
export default {"header":"header_header__Z+0Rp","text":"header_text__G20xb","title":"header_title__NZQmF","subTitle":"header_subTitle__hFKMQ"};